import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../api/index.js';
import { notification } from 'antd';

export const fetchOvertimeStatistics = createAsyncThunk(
    'overtimeStatistics/fetch',
    async ({ query }, { rejectWithValue }) => {
        try {
            const result = await API.overtime.get(query);
            return result;
        } catch (e) {
            notification.error({
                message: 'Error',
                description: e.message || 'Failed to load overtime statistics',
            });
            return rejectWithValue(e.message);
        }
    },
);
